import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanchganicab() {



  const cardData = {



keyword: "Pune to Panchgani Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Panchgani Cabs for families, couples, senior citizens, friends, and groups planning a peaceful hill-station getaway. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way trips, round trips, weekend holidays, family vacations, sightseeing, honeymoon travel, and customized Mahabaleshwar-Panchgani itineraries. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Pune, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes the journey from Pune to Panchgani smooth and convenient. Travelers can also customize their route to explore viewpoints, valleys, caves, lakes, waterfalls, temples, strawberry farms, and nearby hill-station attractions according to their preferred schedule.",

topPlaces: [
  {
    title: "Table Land",
    description: "Table Land is one of Panchgani's most popular attractions and is known for its vast volcanic plateau, panoramic valley views, and pleasant mountain surroundings. Families, couples, and groups visiting from Pune can conveniently include it in their sightseeing itinerary. Garud Cab Service provides private chauffeur-driven cabs with flexible sightseeing and return travel options."
  },
  {
    title: "Sydney Point",
    description: "Sydney Point is a scenic viewpoint in Panchgani offering beautiful views of the Krishna Valley, Dhom Dam, and surrounding hills. It is an excellent stop for travelers interested in photography and peaceful mountain scenery. Customers can visit the viewpoint comfortably as part of a customized Pune to Panchgani cab booking."
  },
  {
    title: "Parsi Point",
    description: "Parsi Point is a popular Panchgani viewpoint known for its wide views of green valleys, hills, and the Krishna River region. Families and couples frequently include this location in their hill-station sightseeing plans. Garud Cab Service allows travelers to cover Parsi Point along with other Panchgani attractions through a flexible private cab itinerary."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is a popular attraction between Panchgani and Mahabaleshwar, known for strawberries, fruit products, chocolates, snacks, and landscaped surroundings. It is a convenient stop for families and tourists traveling through the region. Customers can include Mapro Garden in their Pune to Panchgani cab route and continue sightseeing at nearby destinations."
  },
  {
    title: "Dhom Dam",
    description: "Dhom Dam is a scenic reservoir near Wai surrounded by green hills and peaceful countryside landscapes. It offers a relaxing stop for travelers exploring the Panchgani region. Garud Cab Service provides comfortable private transportation from Pune, allowing customers to add Dhom Dam to their itinerary along with Panchgani and nearby attractions."
  },
  {
    title: "Wai",
    description: "Wai is a historic town situated along the Krishna River and is known for traditional temples, river ghats, heritage architecture, and scenic surroundings. It can be conveniently combined with a Pune to Panchgani journey. Customers can customize their cab booking to include Wai for religious visits, sightseeing, photography, or a short break."
  },
  {
    title: "Rajpuri Caves",
    description: "Rajpuri Caves are a group of ancient caves located near Panchgani and are associated with local religious traditions and natural surroundings. The area provides an interesting combination of heritage, spirituality, and countryside scenery. Travelers can include Rajpuri Caves in a customized Panchgani sightseeing trip with convenient private transportation."
  },
  {
    title: "Devrai Art Village",
    description: "Devrai Art Village is a creative and cultural attraction near Panchgani showcasing handcrafted art, traditional skills, and nature-inspired creations. It provides a different experience for travelers who want to explore local culture beyond conventional tourist spots. Garud Cab Service can include this destination in a customized Pune to Panchgani sightseeing itinerary."
  },
  {
    title: "Kamalgad Fort",
    description: "Kamalgad Fort is a historic hill fort in the Panchgani region surrounded by the scenic Sahyadri landscape. The area is suitable for travelers interested in Maharashtra's forts, history, and mountain scenery. Customers planning an extended sightseeing trip can include the fort region in their private cab itinerary with suitable travel arrangements."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is a popular natural attraction near Mahabaleshwar and becomes especially scenic during the monsoon season. Travelers visiting Panchgani can combine the waterfall with other nearby hill-station attractions. Garud Cab Service provides comfortable cabs from Pune with flexible sightseeing stops and convenient return travel options."
  }
],




"services": [
{
"name": "Pune to Panchgani Cab",
"description": "Book Pune to Panchgani Cab for a comfortable road journey from Pune to the scenic hill station of Panchgani. Suitable sedan, SUV, Ertiga, and Innova Crysta vehicles can be arranged for families, couples, groups, sightseeing, and weekend trips."
},
{
"name": "Panchgani to Pune Cab",
"description": "Choose Panchgani to Pune Cab for convenient return transportation from Panchgani to Pune with professional chauffeur assistance. The service is suitable for tourists, families, business travelers, and passengers carrying luggage after a hill-station stay."
},
{
"name": "Panchgani to Pune Taxi",
"description": "Book Panchgani to Pune Taxi for comfortable private travel between Panchgani and Pune. Well-maintained AC vehicles can be arranged for one-way drops, family travel, business requirements, sightseeing returns, and scheduled intercity journeys."
},
{
"name": "Pune Airport to Panchgani Taxi Fare",
"description": "Check Pune Airport to Panchgani Taxi Fare according to the selected vehicle, travel requirements, pickup time, and journey type. Sedan, SUV, Ertiga, and Innova Crysta options can be arranged for passengers traveling from the airport to Panchgani."
},
{
"name": "Pune to Panchgani Ertiga Cab Booking",
"description": "Make Pune to Panchgani Ertiga Cab Booking for spacious and comfortable transportation suitable for families and small groups. The Ertiga provides practical seating and luggage space for hill-station travel, weekend trips, and sightseeing."
},
{
"name": "Pune to Panchgani Cab Fare",
"description": "Check Pune to Panchgani Cab Fare based on the selected vehicle category, journey type, route, and travel requirements. Customers can choose from comfortable sedan, Ertiga, SUV, and Innova Crysta options for private transportation."
},
{
"name": "Pune to Panchgani Distance by Taxi Fare",
"description": "Pune to Panchgani Distance by Taxi Fare can vary according to the selected vehicle, journey plan, and travel requirements. A private cab provides convenient door-to-door transportation for families, couples, groups, and tourists visiting Panchgani."
},
{
"name": "Pune to Panchgani Taxi",
"description": "Book Pune to Panchgani Taxi for a convenient private journey to Panchgani with professional driver assistance. The service is suitable for weekend getaways, family holidays, sightseeing trips, couples, and groups traveling from Pune."
},
{
"name": "Pune to Panchgani Taxi Distance",
"description": "Plan your journey using Pune to Panchgani Taxi Distance information and select a suitable vehicle for the trip. Comfortable AC taxis can be arranged for direct travel, sightseeing, family vacations, and weekend hill-station journeys."
},
{
"name": "Pune to Panchgani Taxi Fare",
"description": "Check Pune to Panchgani Taxi Fare according to the vehicle type, route, travel schedule, and selected journey option. Sedan, Ertiga, SUV, and Innova Crysta taxis are suitable for comfortable private travel to Panchgani."
},
{
"name": "Pune to Panchgani Innova Crysta Cab Booking",
"description": "Book Pune to Panchgani Innova Crysta Cab for premium and spacious transportation on the hill route. The vehicle is suitable for families, groups, senior passengers, couples, and tourists looking for comfortable seating and ample luggage space."
},
{
"name": "Pune to Panchgani Cab Service",
"description": "Choose Pune to Panchgani Cab Service for convenient chauffeur-driven transportation from Pune to Panchgani. The service supports family trips, weekend holidays, sightseeing, corporate travel, and private journeys with multiple vehicle choices."
},
{
"name": "Pune to Panchgani One Way Cab",
"description": "Book Pune to Panchgani One Way Cab for direct transportation without requiring a return journey. It is a practical option for tourists, families, hotel transfers, weekend travelers, and passengers who need a direct drop at Panchgani."
},
{
"name": "Pune to Panchgani Taxi Fare",
"description": "Get information about Pune to Panchgani Taxi Fare and choose a vehicle according to your passenger count and travel needs. Comfortable private taxis are available for individual travelers, couples, families, and groups."
},
{
"name": "Pune to Panchgani Cab Booking",
"description": "Make Pune to Panchgani Cab Booking in advance for convenient pickup and destination drop arrangements. Customers can select a sedan, Ertiga, SUV, or Innova Crysta based on the number of passengers and luggage requirements."
},
{
"name": "Pune Airport to Panchgani Cab",
"description": "Book Pune Airport to Panchgani Cab for a direct and comfortable transfer from Pune Airport to the Panchgani hill station. Spacious vehicles can accommodate passengers with luggage and provide convenient private transportation."
},
{
"name": "Cheapest Cab from Pune to Panchgani",
"description": "Choose the Cheapest Cab from Pune to Panchgani for a practical travel option while maintaining comfortable private transportation. Sedan and other suitable vehicle categories can be selected according to budget, passenger count, and journey requirements."
},
{
"name": "SUV Cab Pune to Panchgani",
"description": "Book SUV Cab Pune to Panchgani for spacious and comfortable hill-station travel with additional seating and luggage capacity. SUVs are suitable for families, groups, friends, and tourists planning weekend trips or sightseeing."
},
{
"name": "Innova Crysta Pune to Panchgani Cab",
"description": "Choose Innova Crysta Pune to Panchgani Cab for premium private transportation with spacious interiors and comfortable seating. It is well suited for families, groups, senior passengers, corporate travelers, and tourists planning a relaxed hill-station journey."
}
],
"tableData": [
["Pune to Panchgani Cab", "Panchgani to Pune Cab"],
["Panchgani to Pune Taxi", "Pune Airport to Panchgani Taxi Fare"],
["Pune to Panchgani Ertiga Cab Booking", "Pune to Panchgani Cab Fare"],
["Pune to Panchgani Distance by Taxi Fare", "Pune to Panchgani Taxi"],
["Pune to Panchgani Taxi Distance", "Pune to Panchgani Taxi Fare"],
["Pune to Panchgani Innova Crysta Cab Booking", "Pune to Panchgani Cab Service"],
["Pune to Panchgani One Way Cab", "Pune to Panchgani Cab Booking"],
["Pune Airport to Panchgani Cab", "Cheapest Cab from Pune to Panchgani"],
["SUV Cab Pune to Panchgani", "Innova Crysta Pune to Panchgani Cab"]
]
,



whychoose: [
  {
    WhyChooseheading: "Pune to Panchgani Cabs for a Relaxing Hill Station Trip",
    WhyChoosedescription: "A private cab offers a comfortable way to travel from Pune to Panchgani for family holidays, weekend escapes, couples' trips, sightseeing plans, and peaceful getaways in the hills."
  },
  {
    WhyChooseheading: "Convenient Pickup from Pune",
    WhyChoosedescription: "Your journey can begin from a preferred home, hotel, office, residential society, or another accessible location in Pune, allowing the departure to fit conveniently into your travel schedule."
  },
  {
    WhyChooseheading: "Comfortable for Families & Small Groups",
    WhyChoosedescription: "Families, couples, friends, and small groups can select a suitable cab according to passenger count, luggage requirements, and preferred comfort for the journey to Panchgani."
  },
  {
    WhyChooseheading: "Perfect for Weekend Getaways",
    WhyChoosedescription: "Panchgani is well suited for short breaks and weekend holidays, while private cab travel gives passengers flexibility to plan their departure, stay, sightseeing, and return schedule."
  },
  {
    WhyChooseheading: "Explore Panchgani at Your Own Pace",
    WhyChoosedescription: "A private vehicle makes it easier to visit viewpoints, scenic spots, markets, nature attractions, and other places included in your preferred Panchgani sightseeing itinerary."
  },
  {
    WhyChooseheading: "One-Way Cab for Direct Drop",
    WhyChoosedescription: "Travellers heading to Panchgani for a hotel stay, family visit, personal work, or onward journey can select a one-way cab when they do not require transportation back to Pune."
  },
  {
    WhyChooseheading: "Round-Trip Cab for Holiday Plans",
    WhyChoosedescription: "A round-trip cab is useful for families and groups who want private transportation throughout their Panchgani visit and a convenient return journey to Pune after completing the trip."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Provide your Pune pickup point, Panchgani destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip requirement with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Panchgani Cabs?",
    answer: "Yes, Garud Cab Service provides private Pune to Panchgani cab services for families, couples, groups, tourists, weekend travellers, and passengers planning leisure trips."
  },
  {
    question: "Can I book a one-way cab from Pune to Panchgani?",
    answer: "Yes, one-way cab service can be arranged for passengers who need direct transportation from Pune to their preferred hotel, resort, residence, or destination in Panchgani."
  },
  {
    question: "Can I book a round-trip cab for Panchgani?",
    answer: "Yes, round-trip cab arrangements can be planned for weekend holidays, family vacations, sightseeing trips, and other journeys where transportation back to Pune is required."
  },
  {
    question: "Is Pune to Panchgani cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families and groups who want to travel together with comfortable seating and convenient luggage arrangements."
  },
  {
    question: "Can I use the cab for Panchgani sightseeing?",
    answer: "Yes, the private cab can be used for sightseeing around Panchgani according to your preferred itinerary, travel duration, and selected destinations."
  },
  {
    question: "Can I book a cab for a weekend trip to Panchgani?",
    answer: "Yes, private taxi transportation is suitable for weekend getaways, short holidays, family outings, couples' trips, and planned sightseeing journeys from Pune."
  },
  {
    question: "Can couples book a private cab to Panchgani?",
    answer: "Yes, couples can arrange a private cab for weekend getaways, scenic holidays, special occasions, sightseeing trips, and personal travel to Panchgani."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, railway station area, or another preferred accessible location in Pune."
  },
  {
    question: "Can I carry luggage in the Pune to Panchgani cab?",
    answer: "Yes, passengers can carry luggage according to the available space in the selected vehicle. Larger luggage requirements should be shared during booking."
  },
  {
    question: "How can I book a Pune to Panchgani Cab?",
    answer: "Share your Pune pickup location, Panchgani destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Patil",
    feedback: "Our family planned a weekend trip from Pune to Panchgani and chose a private cab. The direct pickup was convenient, and we could manage our sightseeing schedule comfortably.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Joshi",
    feedback: "We travelled to Panchgani with friends by private cab and enjoyed having the flexibility to plan our journey around our hotel and sightseeing schedule.",
    rating: 5
  }
];






  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panchgani Cabs",
  "image": "https://garudcabs.com/assets/images/pune-to-panchgani-cabs.webp",
  "description": "Book Pune to Panchgani Cabs with Garud Cab for safe, comfortable, and reliable hill-station travel. Get Pune to Panchgani taxi and cab services for one way trips, round trips, family holidays, weekend getaways, sightseeing, and airport transfers. Choose Sedan, Ertiga, SUV, Innova, or Innova Crysta vehicles with convenient pickup and drop facilities for a relaxed journey between Pune and Panchgani.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-panchgani-cabs"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Panchgani Cabs | Taxi, Ertiga & One Way Cab | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Panchgani Cabs with Garud Cab for comfortable hill-station travel. Get one way, round trip, airport transfer, sightseeing, and weekend trip taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Pune to Panchgani Cab, Panchgani to Pune Cab, Panchgani to Pune Taxi, Pune Airport to Panchgani Taxi Fare, Pune to Panchgani Ertiga Cab Booking, Pune to Panchgani Taxi Service, Pune to Panchgani One Way Cab, Pune to Panchgani Round Trip Cab, Pune to Panchgani Cab Booking, Pune to Panchgani Car Rental, Panchgani Taxi Service from Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanchganicab;